export const demoVideos = {
    psgMarseille: "https://ligue-1-demo.wearefx.uk/media/psg-marseille/manifest.mpd",
    lensLyon: "https://ligue-1-demo.wearefx.uk/media/lens-lyon/manifest.mpd",
    paris13Rouen: "https://ligue-1-demo.wearefx.uk/media/paris-13-rouen/manifest.mpd",
};
export default demoVideos;
//# sourceMappingURL=demoVideos.js.map